module.exports = __webpack_public_path__ + "img/29m.59721a0d.png";